import EntityModalButton from "./EntityModalButton";

type Props = {
  isEditing: boolean;
  isDisabled?: boolean;
  label: string;
  onClick: () => void;
};

export default function EntityProfileEditModeButton(props: Props) {
  return (
    <EntityModalButton
      disabled={props.isDisabled}
      iconClassName={props.isEditing ? "fa fa-eye" : "fa fa-pencil"}
      kind={props.isEditing ? "white" : "blue"}
      size="sm"
      style={{ alignSelf: "flex-end", minWidth: 76 }}
      onClick={props.onClick}
    >
      {props.isEditing ? "View" : props.label}
    </EntityModalButton>
  );
}
